import React, { useState, useRef } from "react";
import Header from "./components/Header";
import InvoiceForm from "./components/InvoiceForm";
import CombinedContainer from "./components/CombinedContainer";
import Footer from "./components/Footer";
import InvoiceMessage from "./components/InvoiceMessage/InvoiceMessage";
import "./styles.css";

function App() {
  const [showCombinedContainer, setShowCombinedContainer] = useState(false);
  const [invoiceData, setInvoiceData] = useState([]);
  const [qrString, setQrString] = useState("");
  const tableRef = useRef(null);

  const handleVerificationSuccess = (data, qr) => {
    setInvoiceData(data);
    setQrString(qr);
    setShowCombinedContainer(true);

    // Smooth scroll to table after a brief delay to ensure component is mounted
    setTimeout(() => {
      if (tableRef.current) {
        tableRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  return (
    <div className="page-wrapper">
      <Header />
      <main className={`main-content ${showCombinedContainer ? 'show-table' : ''}`}>
        <InvoiceMessage />

        <div className="form-section">
          <InvoiceForm
            setShowCombinedContainer={handleVerificationSuccess}
            setInvoiceData={setInvoiceData}
            setQrString={setQrString}
          />
        </div>

        <div 
          ref={tableRef}
          className={`invoice-section ${showCombinedContainer ? 'visible' : ''}`}
        >
          {showCombinedContainer && (
            <CombinedContainer
              invoiceData={invoiceData}
              qrString={qrString}
            />
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;